/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createTriggeredAction} from '../api'

export const useMutationCreateTriggeredAction = createReactQueryMutationHook('createTriggeredAction', createTriggeredAction)
